/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Components
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';

/**
 * This component is the user's details form.
 *
 * @vue-prop {Object} user the current user object
 *
 * @example
 * ````
 * UserDetails(:user="user" v-slot="{ updating }")
 * ```
 *
 * @category ui.pages.profile.user-profile
 * @exports UserDetails
 * @component
 */
const __vue_script__ = {
    name: 'UserDetails',

    components: { BaseInput },

    props: {
        user: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            changes: {
                realname: this.user.realname,
                phone: this.user.phone,
            },
            updateInProgress: false,
            internalUser: {},
        };
    },

    mounted() {
        this.internalUser = this.user;
    },

    methods: {
        /**
         * Updates the user's details
         */
        async update() {
            const valid = await this.$refs.form.validate();

            if (!valid) {
                return;
            }

            this.updateInProgress = true;

            const params = {
                realname: this.changes.realname,
                phone: this.changes.phone,
                _id: this.user._id
            };

            try {
                await this.$services.account.updateUser(params);
                this.internalUser = Object.assign(this.user, this.changes);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('profile.details.form.profile_update_success').toString(),
                    type: 'success',
                });
            } catch (error) {
                this.$notify({
                    group: 'flashes',
                    title: this.$i18n.t('profile.details.form.profile_update_fail').toString(),
                    text: error.message,
                    type: 'error',
                });

            } finally {
                this.updateInProgress = false;
            }
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-observer", {
    ref: "form",
    staticClass: "user-details-form",
    attrs: { tag: "form", autocomplete: "off" },
    on: {
      submit: function ($event) {
        $event.preventDefault()
        return _vm.update()
      },
    },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function (ref) {
            var invalid = ref.invalid
            return [
              _c("validation-provider", {
                attrs: {
                  rules: "required",
                  slim: true,
                  name: _vm.$t("profile.details.form.full_name"),
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var errors = ref.errors
                        return [
                          _c("base-input", {
                            attrs: {
                              label: _vm.$t("profile.details.form.full_name"),
                              type: "text",
                              name: "realname",
                              errors: errors,
                            },
                            model: {
                              value: _vm.changes.realname,
                              callback: function ($$v) {
                                _vm.$set(_vm.changes, "realname", $$v)
                              },
                              expression: "changes.realname",
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
              _c("validation-provider", {
                attrs: {
                  rules: "required|email",
                  slim: true,
                  name: _vm.$t("profile.details.form.email"),
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var errors = ref.errors
                        return [
                          _c("base-input", {
                            attrs: {
                              label: _vm.$t("profile.details.form.email"),
                              type: "email",
                              name: "email",
                              disabled: true,
                              hint: _vm.$t("profile.details.form.email_hint"),
                              errors: errors,
                            },
                            model: {
                              value: _vm.internalUser.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.internalUser, "email", $$v)
                              },
                              expression: "internalUser.email",
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
              _vm._t("default", null, { updating: _vm.updateInProgress }),
              _c("secondary-toolbar", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: {
                      type: "submit",
                      disabled: _vm.updateInProgress || invalid,
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("profile.details.save_details")))]
                ),
              ]),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/user/UserDetails.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__